import { createVNode as _createVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, mergeProps as _mergeProps, withCtx as _withCtx, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-9a97cc7e")

_pushScopeId("data-v-9a97cc7e")
const _hoisted_1 = { class: "signin" }
const _hoisted_2 = /*#__PURE__*/_createVNode("figure", null, [
  /*#__PURE__*/_createVNode("img", {
    src: "/images/new/signin.png",
    class: "-pc"
  }),
  /*#__PURE__*/_createVNode("img", {
    src: "/images/new/signin_m.png",
    class: "-mobile"
  })
], -1)
const _hoisted_3 = { class: "main__section" }
const _hoisted_4 = /*#__PURE__*/_createVNode("h2", { class: "-bold" }, "로그인하기", -1)
const _hoisted_5 = /*#__PURE__*/_createVNode("p", { class: "-regular" }, [
  /*#__PURE__*/_createTextVNode(" 진료시간을 선택해 온라인대면진료를 받을 수 있고,"),
  /*#__PURE__*/_createVNode("br", { class: "-pc" }),
  /*#__PURE__*/_createTextVNode(" 필요시 처방전을 미리 지정한 약국으로 보내주는 서비스입니다. ")
], -1)
const _hoisted_6 = {
  for: "username",
  class: "-invisibility"
}
const _hoisted_7 = {
  for: "password",
  class: "-invisibility"
}
const _hoisted_8 = { class: "input-box__action" }
const _hoisted_9 = { class: "input-box__options" }
const _hoisted_10 = { class: "remember" }
const _hoisted_11 = /*#__PURE__*/_createVNode("label", {
  for: "rememberMe",
  class: "-bold"
}, "로그인 유지", -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_Alert = _resolveComponent("Alert")
  const _component_InputText = _resolveComponent("InputText")
  const _component_Field = _resolveComponent("Field")
  const _component_Button = _resolveComponent("Button")
  const _component_Checkbox = _resolveComponent("Checkbox")
  const _component_router_link = _resolveComponent("router-link")
  const _component_Specifications = _resolveComponent("Specifications")
  const _component_Form = _resolveComponent("Form")

  return (_openBlock(), _createBlock("main", _hoisted_1, [
    _hoisted_2,
    _createVNode("section", _hoisted_3, [
      (!!_ctx.alert.content)
        ? (_openBlock(), _createBlock(_component_Alert, {
            key: 0,
            alert: _ctx.alert,
            "onUpdate:alert": _cache[1] || (_cache[1] = ($event: any) => (_ctx.alert = $event)),
            isConfirm: true,
            "onUpdate:clear": _cache[2] || (_cache[2] = 
          () => {
            _ctx.alert.content = '';
          }
        )
          }, null, 8, ["alert"]))
        : _createCommentVNode("", true),
      _createVNode(_component_Form, {
        class: "input-box",
        onSubmit: _ctx.login
      }, {
        default: _withId(({ errors }) => [
          _hoisted_4,
          _hoisted_5,
          _createVNode(_component_Field, {
            modelValue: _ctx.value.username,
            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.value.username = $event)),
            name: "username",
            rules: "required|email"
          }, {
            default: _withId(({ field }) => [
              _createVNode("label", _hoisted_6, _toDisplayString(_ctx.t("email")), 1),
              _createVNode(_component_InputText, _mergeProps({
                id: "username",
                type: "text",
                modelValue: field.value,
                "onUpdate:modelValue": ($event: any) => (field.value = $event)
              }, field, {
                class: { 'p-invalid': errors.username },
                placeholder: "이메일주소를 입력해 주세요.",
                "aria-placeholder": "이메일주소를 입력해 주세요."
              }), null, 16, ["modelValue", "onUpdate:modelValue", "class"])
            ]),
            _: 2
          }, 1032, ["modelValue"]),
          _createVNode(_component_Field, {
            modelValue: _ctx.value.password,
            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_ctx.value.password = $event)),
            name: "password",
            rules: "required"
          }, {
            default: _withId(({ field }) => [
              _createVNode("label", _hoisted_7, _toDisplayString(_ctx.t("password")), 1),
              _createVNode(_component_InputText, _mergeProps({
                id: "password",
                type: "password",
                modelValue: field.value,
                "onUpdate:modelValue": ($event: any) => (field.value = $event)
              }, field, {
                class: { 'p-invalid': errors.password },
                placeholder: "비밀번호를 입력해 주세요.",
                "aria-placeholder": "비밀번호를 입력해 주세요."
              }), null, 16, ["modelValue", "onUpdate:modelValue", "class"])
            ]),
            _: 2
          }, 1032, ["modelValue"]),
          _createVNode("span", _hoisted_8, [
            _createVNode(_component_Button, {
              class: "-button -royalBlue",
              type: "submit"
            }, {
              default: _withId(() => [
                _createTextVNode(_toDisplayString(_ctx.t("signin")), 1)
              ]),
              _: 1
            })
          ]),
          _createVNode("div", _hoisted_9, [
            _createVNode("div", _hoisted_10, [
              _createVNode(_component_Checkbox, {
                id: "rememberMe",
                modelValue: _ctx.isRemember,
                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (_ctx.isRemember = $event)),
                binary: true
              }, null, 8, ["modelValue"]),
              _hoisted_11
            ]),
            _createVNode(_component_router_link, {
              class: "-link -bold",
              to: { name: _ctx.RouterName.FORGOT_PASSWORD }
            }, {
              default: _withId(() => [
                _createTextVNode(_toDisplayString(_ctx.t("forgotPassword")), 1)
              ]),
              _: 1
            }, 8, ["to"]),
            _createVNode(_component_router_link, {
              class: "-link -bold",
              to: { name: _ctx.RouterName.SIGNUP }
            }, {
              default: _withId(() => [
                _createTextVNode(_toDisplayString(_ctx.t("signup")), 1)
              ]),
              _: 1
            }, 8, ["to"])
          ]),
          _createVNode(_component_Specifications)
        ]),
        _: 1
      }, 8, ["onSubmit"])
    ])
  ]))
})